import React, { useContext, useEffect, useState } from 'react';

import SettingsContext from '../context/SettingsContext';

import Modal from '../components/Shell/Modal';
import { capitalizeFirstLetter } from '../components/helpers/functions';
import { Spinner } from '../components/Form';
import { Button } from '../components/Button';

import { TemplateField } from '../components/Attributes/Attributes_old';

import useRequired from '../hooks/useRequired';
import useModal from '../hooks/useModal';

const MODAL_NAME = 'tableCSVExport';

/*
	accepts options:

		columns: Array
		selected: Array of ids
		onExport: Function
*/

export default () => {
	const { open: options, setClose } = useModal(MODAL_NAME);

	const [selectedColumns, setSelectedColumns] = useState([]);
	const [filename, setFilename] = useState('Scipods');
	const {
		settings,
		loading: isLoadingSettings,
		refresh: refreshSettings,
		update: updateSettings,
	} = useContext(SettingsContext);

	useEffect(() => {
		setSelectedColumns([
			'manufacturer.name',
			...(settings?.user ? settings?.user[options?.columnManagementKey] : []),
		]);
	}, [options?.columns]);

	useEffect(() => {
		setFilename(options.filename);
	}, [options?.filename]);

	return (
		<Modal
			title={
				<div className="flex items-center">
					{`Exporting ${options?.selected?.length || 'All'} Rows`}{' '}
					{isLoadingSettings && <Spinner className="ml-2" />}
				</div>
			}
			open={!!options}
			onClose={() => setClose()}
		>
			<TemplateField
				required
				name="File name"
				placeholder="Enter file name"
				value={filename}
				onChange={(index, filename) => setFilename(filename)}
			/>
			<div class="text-gray-500 text-sm my-2 mt-4">Columns to Export</div>
			<fieldset>
				<legend className="sr-only">Manage Columns</legend>
				<div className="space-y-2.5">
					{options?.columns?.map((column) => (
						<div className="relative flex items-start">
							<div className="flex h-6 items-center">
								<input
									id={column?.accessorKey}
									aria-describedby="comments-description"
									name={column?.accessorKey}
									type="checkbox"
									className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
									disabled={!column?.column?.removable}
									checked={selectedColumns?.includes(column?.accessorKey)}
									onClick={(e) =>
										setSelectedColumns(
											e.target.checked
												? [...selectedColumns, column?.accessorKey]
												: selectedColumns?.filter(
														(c) => c !== column?.accessorKey
												  )
										)
									}
								/>
							</div>
							<div className="ml-3 text-xs leading-6">
								<label htmlFor={column?.accessorKey} className="text-gray-600">
									{capitalizeFirstLetter(column?.header?.toLowerCase())}
								</label>
							</div>
						</div>
					))}
				</div>
			</fieldset>

			<div className="flex justify-end">
				<Button
					disabled={
						typeof options?.onExport !== 'function' &&
						useRequired({ filename }, ['filename'])
					}
					onClick={() =>
						typeof options?.onExport === 'function'
							? options?.onExport({ columns: selectedColumns, filename })
							: {}
					}
				>
					Export to CSV
				</Button>
			</div>
		</Modal>
	);
};
